export default __webpack_public_path__ + "static/media/orgstructure.8f0510f0.png";